import { render, staticRenderFns } from "./AiaPhone.vue?vue&type=template&id=57427213"
import script from "./AiaPhone.vue?vue&type=script&lang=js"
export * from "./AiaPhone.vue?vue&type=script&lang=js"
import style0 from "./AiaPhone.vue?vue&type=style&index=0&id=57427213&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports